import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { makeStyles } from '@material-ui/core';

import OnOffByScroll from '../../../Animation/onOffByScroll';
import { AuthContext } from '../../../auth';
import various from '../../../General/various';
import {
  instructorDetailForInstructor,
  memberDetailByUserEmail,
} from '../../../Apis/apiOfManaged';

import Footer from '../../../Footer/footer';
import { localStorageArrayHandler } from '../../../CommonFunction/managePermission';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    margin: '0px 0px 80px 0px',
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      textAlign: 'start',
      '& > span': {
        display: 'inline-block',
        marginRight: '24px',
        fontSize: '0.9rem',
      },
      '& #title': {
        fontWeight: 'bold',
        fontSize: theme.typography.fontSize,
      },
    },
  },
  title: {},
  dataContainer: {},
  button: {},
  detailContainer: {
    display: 'flex',
    margin: '72px 0px',
    '@media screen and (max-width:750px)': {
      flexWrap: 'wrap',
    },
    '& $title': {
      width: '50%',
      marginRight: '32px',
      textAlign: 'start',
      '& > span': {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
      },
      '& > p': {
        fontSize: '0.8em',
      },
      '@media screen and (max-width:750px)': {
        width: '80%',
      },
    },
    '& $dataContainer': {
      width: '50%',
      marginLeft: '56px',
      textAlign: 'start',
      '@media screen and (max-width:750px)': {
        width: '100%',
        marginLeft: '0px',
      },
      '& > div': {
        marginBottom: '24px',
        flexWrap: 'wrap',
        '& > img': {
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
          //   border: '2px solid black', // 薄いグレーの縁取り
          borderRadius: '8px', // 角を少し丸く
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)', // 薄い影
        },
        '& > span': {
          fontSize: '0.9em',
          fontWeight: 'bold',
        },
        '& > input, & > textarea': {
          width: '100%',
          height: '40px',
          padding: '8px',
          fontFamily: theme.typography.fontFamily,
          border: '0.5px solid grey',
          borderRadius: '0.9em',
          boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.1) inset',
          '&:focus': {
            outline: `1.2px ${theme.palette.primary.main} outset`,
          },
        },
        '& > textarea': {
          height: '240px',
        },
      },
    },
    '& $button': {
      width: '100%',
      textAlign: 'start',
      '& > button': {
        width: '100%',
        display: 'inline-block',
        fontFamily: theme.typography.fontFamily,
        fontWeight: 'bold',
        borderRadius: '0.9em',
        border: 'none',
        padding: '8px 12px',
        backgroundColor: 'rgba(192,192,192, 1)',
        boxShadow: '0px 0px 15px rgba(0,0,0,0.1)',
        color: '#000',
        cursor: 'pointer',
      },
    },
  },
}));

const InstructorDetail = (props) => {
  const index = props.index;
  const instructor = props.instructor;
  const member = props.member;
  const paymentMethod = { ...instructor.payment_method };

  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  // console.log('paymentMethod', paymentMethod);

  //   Functions
  const genelateBankAccountInputValue = (bankAccount) => {
    let isDefualt;
    let isActive;
    if (bankAccount.is_default) {
      isDefualt = '[デフォルト]';
    } else {
      isDefualt = ''; // デフォルトでない場合は空文字
    }
    if (bankAccount.is_active) {
      isActive = '[稼働中]';
    } else {
      isActive = '[停止中]';
    }
    // 銀行口座の表示形式を整形
    return `${bankAccount.bank_name} | ${bankAccount.branch_name} | ${
      bankAccount.account_type === 'ordinary' ? '普通' : '当座'
    } | ${bankAccount.account_number} | ${isDefualt} ${isActive}`;
  };

  const genelatePaypayAccountInputValue = (paypayAccount) => {
    let isDefualt;
    let isActive;
    if (paypayAccount.is_default) {
      isDefualt = '[デフォルト]';
    } else {
      isDefualt = ''; // デフォルトでない場合は空文字
    }
    if (paypayAccount.is_active) {
      isActive = '[稼働中]';
    } else {
      isActive = '[停止中]';
    }
    // PayPay口座の表示形式を整形
    return `${paypayAccount.paypay_id} | ${isDefualt} ${isActive}`;
  };

  const genelatePaymentLinksAccountInputValue = (paymentLinksAccount) => {
    let isDefualt;
    let isActive;
    if (paymentLinksAccount.is_default) {
      isDefualt = '[デフォルト]';
    } else {
      isDefualt = ''; // デフォルトでない場合は空文字
    }
    if (paymentLinksAccount.is_active) {
      isActive = '[稼働中]';
    } else {
      isActive = '[停止中]';
    }
    // PaymentLinks口座の表示形式を整形
    return `${paymentLinksAccount.amount.toLocaleString()}円 | ${isDefualt} ${isActive}`;
  };
  //   決済方法が増えたら追加

  //   Handler
  const handleClick = (action, uuid) => {
    if (action === 'update') {
      navigate(various.general.instructorUpdate, {
        state: { uuid: uuid, previous: location.pathname },
      });
    } else if (action === 'methodUpdate') {
      navigate(various.general.instructorPaymentMethodUpdate, {
        state: { uuid: uuid, previous: location.pathname },
      });
    } else if (action === 'create') {
      navigate(various.general.instructorPaymentMethodCreate, {
        state: { uuid: uuid, previous: location.pathname },
      });
    }
  };

  return (
    <>
      <div className={classes.detailContainer}>
        <div className={classes.title}>
          <span>講師プロフィール{index > 1 ? index : ''}</span>
          <p>
            現在設定されている講師プロフィール情報です。必要に応じて変更してください。
          </p>
        </div>
        <div className={classes.dataContainer}>
          <div>
            <span>御写真</span>
            <img src={instructor.image} alt={`Instructor${index}`} />
          </div>
          <div>
            <span>講師名</span>
            <input type="text" value={instructor.name} readOnly />
          </div>
          <div>
            <span>会員氏名</span>
            <input
              type="text"
              value={member.last_name + member.first_name}
              readOnly
            />
          </div>
          <div>
            <span>Emailアドレス</span>
            <input type="text" value={instructor.user.email} readOnly />
          </div>
          <div>
            <span>Biography</span>
            <textarea type="textarea" value={instructor.biography} readOnly />
          </div>
          <div>
            <span>稼働ステータス</span>
            <input
              type="text"
              value={instructor.is_working ? '稼働中' : '停止中'}
              readOnly
            />
          </div>
          <div className={classes.button}>
            <button
              type="submit"
              onClick={() => handleClick('update', instructor.uuid)}
            >
              登録内容の変更
            </button>
          </div>
        </div>
      </div>
      {Object.keys(paymentMethod).length > 0 && (
        <>
          <hr
            style={{
              borderTop: '0.1px dashed grey',
              width: '70%',
              textAlign: 'left',
            }}
          />
          <div className={classes.detailContainer}>
            <div className={classes.title}>
              <span>決済方法</span>
              <p>
                現在設定されている決済方法です。必要に応じて登録または変更してください。
              </p>
            </div>
            <div className={classes.dataContainer}>
              {paymentMethod.bank_accounts &&
                paymentMethod.bank_accounts.length > 0 && (
                  <div>
                    <span>銀行口座</span>
                    {paymentMethod.bank_accounts.map((account, index) => (
                      <input
                        key={index}
                        type="text"
                        style={{ marginBottom: '8px' }}
                        value={genelateBankAccountInputValue(account)}
                        readOnly
                      />
                    ))}
                  </div>
                )}
              {paymentMethod.paypay_accounts &&
                paymentMethod.paypay_accounts.length > 0 && (
                  <div>
                    <span>PayPay口座</span>
                    {paymentMethod.paypay_accounts.map((account, index) => (
                      <input
                        key={index}
                        type="text"
                        style={{ marginBottom: '8px' }}
                        value={genelatePaypayAccountInputValue(account)}
                        readOnly
                      />
                    ))}
                  </div>
                )}
              {paymentMethod.payment_links_accounts &&
                paymentMethod.payment_links_accounts.length > 0 && (
                  <div>
                    <span>PaymentLinks口座</span>
                    {paymentMethod.payment_links_accounts.map(
                      (account, index) => (
                        <input
                          key={index}
                          type="text"
                          style={{ marginBottom: '8px' }}
                          value={genelatePaymentLinksAccountInputValue(account)}
                          readOnly
                        />
                      )
                    )}
                  </div>
                )}
              {/* 他の決済方法があればここに追加 */}
              <div className={classes.button}>
                <button
                  type="submit"
                  onClick={() => handleClick('methodUpdate', instructor.uuid)}
                >
                  登録内容の変更
                </button>
              </div>
              <div className={classes.button}>
                <button
                  type="submit"
                  style={{ backgroundColor: 'darkslategray', color: '#F3F3F3' }}
                  onClick={() => handleClick('create', instructor.uuid)}
                >
                  決済方法の新規追加
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <hr />
    </>
  );
};

const InstructorSettingsForInstructor = () => {
  const { isAuth, user } = useContext(AuthContext);
  const permissions = localStorageArrayHandler('parse', various.permissionKey);

  const [date, setDate] = useState();
  const [member, setMember] = useState(null);
  const [instructors, setInstructors] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  //   const CRUMBS = [
  //     { name: '管理画面Top', path: '/manage/index' },
  //     { name: '指導者一覧', path: '/manage/instructor_index' },
  //     { name: '決済方法更新', path: '/manage/instructor_payment_method_update' },
  //   ];

  //   if (user) console.log('user', user);
  // if (instructors) console.log('instructors', instructors);
  //   if (member) console.log('member', member);
  //   console.log('permissions', permissions);

  // Init
  useEffect(() => {
    const weekday = ['日', '月', '火', '水', '木', '金', '土'];
    const d = new Date();
    setDate(
      d.getFullYear() +
        '年' +
        (d.getMonth() + 1) +
        '月' +
        d.getDate() +
        '日' +
        '（' +
        weekday[d.getDay()] +
        '）'
    );
  }, []);

  useEffect(() => {
    if (user) {
      instructorDetailForInstructor(setInstructors, user.email);
      memberDetailByUserEmail(setMember, user.email);
    }
  }, [user]);

  // Handler
  const handleAuth = () => {
    navigate(various.general.login, { state: { previous: location.pathname } });
  };

  return (
    <>
      <div style={{ margin: '80px' }}>
        <OnOffByScroll place="General" />
      </div>
      {!isAuth ? (
        <>
          <div>
            <span
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={handleAuth}
            >
              ログイン
            </span>
            してください。
          </div>
        </>
      ) : (permissions.includes('admin') ||
          permissions.includes('instructor') ||
          permissions.includes('organizer')) &&
        instructors &&
        instructors.length > 0 &&
        member ? (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">講師設定</span>
              <span>{date}</span>
            </div>
          </div>
          <hr />
          <div className={classes.container}>
            {instructors.map((instructor, index) => (
              <InstructorDetail
                key={instructor.uuid}
                instructor={instructor}
                member={member}
                index={index + 1}
              />
            ))}
          </div>
        </>
      ) : permissions === 'null' ? (
        setTimeout(() => {
          window.location.reload(true);
        }, 500)
      ) : (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">講師設定</span>
              <span>{date}</span>
            </div>
          </div>
          <hr />
          <div className={classes.container}>権限がありません</div>
        </>
      )}
      <Footer />
    </>
  );
};
export default InstructorSettingsForInstructor;
